const IMAGE_COMMON = Object.freeze({
    WELCOME: {
        height: 155,
        centered: true,
        name: 'welcome',
    },
    NICE_TO_MEET: {
        height: 200,
        width: 253,
        name: 'nice_to_meet'
    },
    NICE_TO_MEET_V2: {
        height: 200,
        width: 253,
        name: 'nice_to_meet_you_2'
    },
    CHECK: {
        height: 80,
        centered: true,
        name: 'check'
    },
    WHY_US: {
        height: 300,
        centered: true,
        name: 'why_brella'
    },
    PEACE_OF_MIND_MOM_WITH_CHILD_BG: {
        width: 177,
        centered: true,
        name: 'peace_of_mind_mom_with_child_bg'
    },
    PEACE_OF_MIND_PAYMENT: {
        width: 177,
        centered: true,
        name: 'peace_of_mind_payment'
    },
    PEACE_OF_MIND_CONCIERGE: {
        width: 177,
        centered: true,
        name: 'peace_of_mind_concierge'
    },
    SPECTRUM: {
        height: 78,
        width: 620,
        name:'spectrum'
    },
    SPECTRUM_SPANISH: {
        height: 78,
        width: 620,
        name: 'spectrum_(spanish)'
    },
    MONETIZATION_ON: {
        spaced: true,
        name: 'monetization_on'
    },
    CIRCLE_CHECK: {
        width: 32,
        centered: true,
        name: 'icon_check'
    },
    CONDITION_MODERATE_112PX: {
        height: 112,
        centered: true,
        name:'condition_moderate'
    },
    CONDITION_MODERATE_96PX: {
        height: 96,
        centered: true,
        name: 'condition_moderate'
    },
    CONDITION_SEVERE_112PX: {
        height: 112,
        centered: true,
        name:'condition_severe'
    },
    CONDITION_SEVERE_96PX: {
        height: 96,
        centered: true,
        name: 'condition_severe'
    },
    CONDITION_CATASTROPHIC_112PX: {
        height: 112,
        centered: true,
        name:'condition_catastrophic'
    },
    CONDITION_CATASTROPHIC_96PX: {
        height: 96,
        width: 144,
        centered: true,
        name:'condition_catastrophic'
    },
    PEACE_OF_MIND_MOM_WITH_CHILD: {
        height: 163,
        name: 'peace_of_mind_mom_with_child'
    },
    AMBER: {
        height: 80,
        centered: true,
        name: 'amber'
    },
    RAY: {
        height: 160,
        centered: true,
        name: 'ray'
    },
    THERMOMETER: {
        height: 96,
        centered: true,
        name:'thermometer'
    },
    LUNGS: {
        height: 96,
        width: 89,
        centered: true,
        name: 'lungs'
    },
    WALLET_CASH: {
        height: 96,
        width: 77,
        centered: true,
        name: 'wallet_cash'
    },
    AMBER_160PX: {
        height: 160,
        centered: true,
        name: 'amber'
    },
    TORSO_BELLY: {
        height: 96,
        centered: true,
        name: 'torso_belly'
    },
    APPLICATION_MIC: {
        height: 96,
        centered: true,
        name: 'application_mic'
    },
    ENVELOPE_PAID: {
        height: 96,
        width: 88,
        centered: true,
        name: 'envelope_paid'
    },
    SERENA: {
        height: 160,
        centered: true,
        name: 'serena'
    },
    TORSO_CHEST: {
        height: 96,
        centered: true,
        name: 'torso_chest'
    },
    CAR: {
        height: 78,
        width: 120,
        centered: true,
        name: 'car'
    },
    MARCUS: {
        height: 160,
        centered: true,
        name: 'marcus'
    },
    KNEE: {
        height: 96,
        centered: true,
        name: 'knee'
    },
    STOMACH: {
        height: 96,
        width: 92,
        centered: true,
        name: 'stomach'
    },
    GET_MEDICAL_ATTENTION: {
        height: 160,
        centered: true,
        name:'get_medical_attention'
    },
    WHAT_HAPPENED: {
        height: 160,
        centered: true,
        name: 'what_happened'
    },
    UPLOAD_DOCS: {
        height: 160,
        centered: true,
        name:'upload_docs'
    },
    SELECT_PAYOUT_PREFERENCE: {
        height: 160,
        centered: true,
        name: 'select_payout_preference'
    },
    LEVERS: {
        width: 120,
        centered: true,
        name: 'levers'
    },
    EASY_ADMIN: {
        width: 210,
        centered: true,
        name: 'easy_admin'
    },
    DOLLAR: {
        avatar: true,
        name: 'dollar'
    },
    PAYMENT_METHOD: {
        height: 100,
        width: 100,
        name: 'payment_method'
    },
    THANK_YOU: {
        height: 210,
        centered: true,
        name: 'thank_you'
    },
});

export default IMAGE_COMMON;
